import React from "react";
import ListaInRule from "../components/ListaInRule";
import EqualRule from "../components/EqualRule";
import RegExpRule from "../components/RegExpRule";
import DefaultRule from "../components/DefaultRule";
import ListaNotInRule from "../components/ListaNotInRule";

export class RulesFactory {
  static createRule({ idRule, ...props }) {
    switch (idRule) {
      case "listaIn":
      case "in":
        return extraProps => <ListaInRule {...props} {...extraProps} />;
      case "listaNotIn":
      case "notIn":
        return extraProps => <ListaNotInRule {...props} {...extraProps} />;
      case "IgualA":
      case "equal":
        return extraProps => <EqualRule {...props} {...extraProps} />;
      case "RegExp":
      case "regexp":
        return extraProps => <RegExpRule {...props} {...extraProps} />;
      case "Default":
      case "default":
        return extraProps => <DefaultRule {...props} {...extraProps} />;
      default:
        return null;
    }
  }
}
